import { ConsultaSeguimentoAplicacaoItemModel } from '@mchat-rf/consulta-seguimento/model-consultaSeguimento'
import { SimNaoEnum } from 'components/form'

export enum ConsultaSeguimentoPergunta02IgnoraEnum {
  IGNORA_SONS = 'IGNORA_SONS',
  IGNORA_PESSOAS = 'IGNORA_PESSOAS',
}

export enum ConsultaSeguimentoPergunta02ResultadoExameEnum {
  AUDICAO_NORMAL = 'AUDICAO_NORMAL',
  AUDICAO_ABAIXO = 'AUDICAO_ABAIXO',
  NAO_DEFINITIVO = 'NAO_DEFINITIVO',
}

export interface ConsultaSeguimentoPergunta02Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_02_IGNORA?: Record<ConsultaSeguimentoPergunta02IgnoraEnum, SimNaoEnum | undefined>
  PERGUNTA_02_FEZ_EXAME?: SimNaoEnum
  PERGUNTA_02_RESULTADO_EXAME?: ConsultaSeguimentoPergunta02ResultadoExameEnum
}
